/** Where the other apps live. Defaults suit a single host; override for split deployments. */
export const DASHBOARD_URL = import.meta.env.VITE_DASHBOARD_URL || "/parent/";
export const PORTAL_URL = import.meta.env.VITE_PORTAL_URL || "/wall/";
